// Краткие справки об обновлениях — книжечка рядом с уведомлениями
// (UpdatesBook). Новое — сверху. id — дата и короткое имя; по id первой
// записи панель понимает, что появилось непрочитанное, поэтому id однажды
// выпущенной записи не меняется.
//
// Пишутся для пользователя: что стало лучше и где это найти, без внутренних
// подробностей. Текст — на русском и английском (язык интерфейса).

const UPDATES_LOG = [
  {
    id: "2026-10-30-translator",
    date: "2026-10-30",
    title: { ru: "Переводчик в поле ответа", en: "Translator in the reply field" },
    text: {
      ru: "Рядом с «Быстрыми ответами» в поле ответа появилась кнопка переводчика. Она открывает панель прямо над полем: слева пишете по-русски, справа сразу появляется перевод на немецкий, а переписка остаётся перед глазами. Языки выбираются сверху, кнопка ⇄ меняет их местами вместе с текстом. «В ответ» (или Ctrl + Enter) вставляет перевод в поле ответа. На компьютере переводчик открывается и закрывается по Alt + L. Переводит нейросеть с учётом объявления и переписки: понимает, о чём речь, и обращается к покупателю так же, как он пишет, — на «du» или «Sie».",
      en: "A translator button now sits next to Quick replies in the reply field. It opens a panel right above the field: type in your language on the left and the German translation appears on the right, while the conversation stays in view. Pick languages at the top; ⇄ swaps them together with the text. “Use in reply” (or Ctrl + Enter) puts the translation into the reply field. On desktop, Alt + L opens and closes the translator. Translations are done by AI with the listing and the conversation in mind: it understands what's being discussed and addresses the buyer the way they write — with “du” or “Sie”."
    }
  },
  {
    id: "2026-10-30-long-replies",
    date: "2026-10-30",
    title: { ru: "Длинные ответы на телефоне", en: "Long replies on your phone" },
    text: {
      ru: "Когда ответ на телефоне длиннее пары строк, кнопки слева от поля встают столбиком, и места под текст становится больше. С четвёртой строки над «Отправить» появляется кнопка ⤢. Она разворачивает поле на весь экран чата, а ⤡ сворачивает его обратно.",
      en: "When a reply on your phone runs past a couple of lines, the buttons left of the field stack into a column, giving the text more room. From the fourth line a ⤢ button appears above Send: it expands the field to the whole chat screen, and ⤡ collapses it back."
    }
  },
  {
    id: "2026-10-28-push",
    date: "2026-10-28",
    title: { ru: "Уведомления на телефон без Telegram", en: "Phone notifications without Telegram" },
    text: {
      ru: "Новые сообщения покупателей теперь приходят уведомлением на телефон или компьютер — без Telegram. На iPhone (iOS 16.4 и новее): откройте панель в Safari → «Поделиться» → «На экран «Домой»», запустите её с иконки и включите «Настройки» → «Уведомления на этом устройстве». На Android и компьютере этот переключатель работает прямо в браузере. Нажатие на уведомление открывает нужный диалог, а на иконке панели видно число непрочитанных.",
      en: "New buyer messages now arrive as notifications on your phone or computer — no Telegram needed. On iPhone (iOS 16.4 or later): open the panel in Safari → Share → Add to Home Screen, launch it from the icon and turn on Settings → Notifications on this device. On Android and desktop the same switch works right in the browser. Tapping a notification opens that conversation, and the panel icon shows the unread count."
    }
  },
  {
    id: "2026-10-28-hotkeys",
    date: "2026-10-28",
    title: { ru: "Горячие клавиши в сообщениях", en: "Keyboard shortcuts in messages" },
    text: {
      ru: "Диалоги можно разбирать без мыши: Alt + ↓ / ↑ — следующий и предыдущий диалог, Alt + Shift + ↓ — следующий непрочитанный, Ctrl + Enter — отправить и сразу открыть следующий непрочитанный, Alt + A — в архив, Alt + 1…9 — быстрый ответ с этим номером. Все клавиши — по Alt + / или ссылке «Все клавиши» под полем ответа. На Mac вместо Alt — ⌥, вместо Ctrl — ⌘.",
      en: "Work through conversations without the mouse: Alt + ↓ / ↑ — next and previous conversation, Alt + Shift + ↓ — next unread, Ctrl + Enter — send and open the next unread, Alt + A — archive, Alt + 1…9 — quick reply with that number. See all shortcuts with Alt + / or the “All shortcuts” link under the reply field. On Mac use ⌥ instead of Alt and ⌘ instead of Ctrl."
    }
  },
  {
    id: "2026-10-28-photo-editor",
    date: "2026-10-28",
    title: { ru: "Редактор фото при публикации", en: "Photo editor when publishing" },
    text: {
      ru: "В окне публикации у каждого фото появилась кнопка редактора: обрезка (свободная, 1:1, 4:3, 3:4), поворот и яркость. Отредактированное фото встаёт на своё место, обложка не меняется.",
      en: "Each photo in the publish window now has an editor button: crop (free, 1:1, 4:3, 3:4), rotate and brightness. The edited photo stays in its place, and the cover doesn't change."
    }
  },
  {
    id: "2026-10-28-bulk-ads",
    date: "2026-10-28",
    title: { ru: "Массовые действия с объявлениями", en: "Bulk actions for listings" },
    text: {
      ru: "В «Объявлениях» карточки можно отмечать галочками и разом активировать, отправить в резерв или удалить. Выбранные обрабатываются разом, в конце приходит один итог, а остановить можно в любой момент.",
      en: "In Listings you can tick several cards and activate, reserve or delete them all at once. They're processed all at once, you get a single summary at the end, and you can stop at any time."
    }
  },
  {
    id: "2026-10-24-support",
    date: "2026-10-24",
    title: { ru: "Обновления и тикеты", en: "Updates and tickets" },
    text: {
      ru: "Здесь — короткие справки о том, что нового в панели. Нашли ошибку — нажмите «Создать тикет», и он придёт администратору. Тикет можно отправить и из бота: «Помощь» → «Создать тикет».",
      en: "Short notes on what's new in the panel live here. Found a bug? Press “Create ticket” and it goes to the admin. You can also send a ticket from the bot: Help → Create ticket."
    }
  },
  {
    id: "2026-10-23-category-language",
    date: "2026-10-23",
    title: { ru: "Язык категорий", en: "Category language" },
    text: {
      ru: "Категории и параметры объявлений теперь можно показывать по-немецки, по-русски или по-английски: «Настройки» → «Язык категорий». В Kleinanzeigen объявление уходит как обычно — на немецком.",
      en: "Listing categories and parameters can now be shown in German, Russian or English: Settings → Category language. Listings still go to Kleinanzeigen in German, as usual."
    }
  }
];

export default UPDATES_LOG;
